module.exports = __webpack_public_path__ + "static/media/label-1.87f748d6.svg";